/* RE:FORM — Interaktion: Scroll-Reveal, Header-Zustand, FAQ-Exklusivität */
(function () {
  'use strict';

  var root = document.documentElement;

  document.body.classList.add('rf-shell');

  var lastKnown = false;
  function onScroll() {
    var scrolled = window.scrollY > 24;
    if (scrolled !== lastKnown) {
      document.body.classList.toggle('rf-scrolled', scrolled);
      lastKnown = scrolled;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll('.rf-reveal:not(.rf-in)');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('rf-in');
  }

  /* Zurück zur letzten Position. Shopify-Seiten lädt der Browser beim
     Zurückgehen oft komplett neu; dabei landete man wieder ganz oben.
     Die Scrollposition jeder Seite wird deshalb beim Verlassen gemerkt und
     beim Zurückkommen wiederhergestellt. Hat der Browser sie schon selbst
     richtig gesetzt oder scrollt man sofort selbst, passiert nichts. */
  var scrollKey = 'rf-scroll:' + location.pathname + location.search;

  function saveScroll() {
    try { sessionStorage.setItem(scrollKey, String(Math.round(window.scrollY))); } catch (err) {}
  }

  window.addEventListener('pagehide', saveScroll);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') saveScroll();
  });

  (function restoreScroll() {
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var isBack = nav ? nav.type === 'back_forward' : (performance.navigation && performance.navigation.type === 2);
    if (!isBack) return;
    var saved = 0;
    try { saved = parseInt(sessionStorage.getItem(scrollKey), 10) || 0; } catch (err) {}
    if (saved < 80) return;

    var userMoved = false;
    var stop = function () { userMoved = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
      window.addEventListener(type, stop, { passive: true, once: true });
    });

    var apply = function () {
      if (userMoved || Math.abs(window.scrollY - saved) < 60) return;
      try { window.scrollTo({ top: saved, left: 0, behavior: 'instant' }); }
      catch (err) { window.scrollTo(0, saved); }
    };

    apply();
    window.addEventListener('load', function () {
      apply();
      setTimeout(apply, 250);
    });
  })();

  /* Zurück-Links im Produktkopf ("Alle Guides", "Zur Startseite"): Kommt man
     von einer anderen Seite dieses Shops, geht der Link einen Schritt zurück
     statt eine neue Seite zu öffnen. So landet man genau dort, wo man vorher
     war, statt auf einer Zwischenseite von oben. Ohne Vorgeschichte (direkter
     Aufruf, Link aus Google) führt er normal zum eingetragenen Ziel. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[data-rf-back]') : null;
    if (!link || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!document.referrer || window.history.length < 2) return;
    var from;
    try { from = new URL(document.referrer); } catch (err) { return; }
    if (from.origin !== location.origin) return;
    if (from.pathname === location.pathname) return;
    if (/^\/(cart|checkouts?|account)(\/|$)/.test(from.pathname)) return;
    e.preventDefault();
    window.history.back();
  });

  /* Im Theme-Editor steht alles sofort, ohne Bewegung. */
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  if (reduce || designMode || !('IntersectionObserver' in window)) {
    revealAll();
    root.classList.remove('rf-anim');
    if (designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        revealAll(e.target);
        bindFaq(e.target);
      });
    }
  } else {
    /* Einblenden, sobald ein Element ein Stück weit im Bild ist (10 % über
       der Unterkante). So sieht man die Bewegung, statt dass sie unterhalb
       des Bildschirms verpufft. Die Animationen selbst stehen in
       reform-motion.css und bewegen nur opacity und transform. */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rf-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    var firstSection = document.querySelector('main > .shopify-section');

    var observe = function (scope) {
      var nodes = (scope || document).querySelectorAll('.rf-reveal:not(.rf-in)');
      var vh = window.innerHeight;
      var now = [];
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (firstSection && firstSection.contains(node)) {
          /* Erster Abschnitt: läuft schon über die CSS-Animation beim Laden. */
          node.classList.add('rf-in');
        } else if (node.getBoundingClientRect().top < vh * 0.9) {
          /* Schon im Bild oder darüber: im nächsten Bild einblenden, damit
             der Übergang sichtbar abläuft. */
          now.push(node);
        } else {
          io.observe(node);
        }
      }
      if (now.length) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            for (var j = 0; j < now.length; j++) now[j].classList.add('rf-in');
          });
        });
      }
    };

    observe();

    document.addEventListener('shopify:section:load', function (e) {
      observe(e.target);
      bindFaq(e.target);
    });
  }

  /* FAQ: Es ist immer nur eine Antwort offen. Wird beim Öffnen eine längere
     Antwort weiter oben geschlossen, würde die angetippte Frage nach oben
     wegspringen. Die Scrollposition wird deshalb so ausgeglichen, dass die
     Frage genau dort stehen bleibt, wo sie angetippt wurde. */
  function bindFaq(scope) {
    var groups = (scope || document).querySelectorAll('[data-rf-faq]');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        if (group.__rfFaq) return;
        group.__rfFaq = true;
        var items = group.querySelectorAll('details.rf-faq__item');
        for (var i = 0; i < items.length; i++) {
          var sum = items[i].querySelector('summary');
          if (!sum) continue;
          sum.addEventListener('click', function () {
            var item = this.parentElement;
            if (item.open) return;
            var before = this.getBoundingClientRect().top;
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== item && items[j].open) items[j].removeAttribute('open');
            }
            var diff = this.getBoundingClientRect().top - before;
            if (diff) {
              try { window.scrollBy({ top: diff, left: 0, behavior: 'instant' }); }
              catch (e) { window.scrollBy(0, diff); }
            }
          });
        }
      })(groups[g]);
    }
  }

  bindFaq();

  /* Weiche Sprünge zu Ankern auf derselben Seite. Der Skip-Link (#MainContent)
     bleibt beim Browser, damit der Tastaturfokus korrekt mitwandert. Die
     Adresse bekommt kein #-Ziel: die Buchungs-App kann damit nicht umgehen. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!link) return;
    var id = link.getAttribute('href');
    if (!id || id === '#' || id.length < 2 || id === '#MainContent') return;
    var target;
    try { target = document.querySelector(id); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    revealAll(target);
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  root.classList.add('rf-ready');
})();